// extracted by mini-css-extract-plugin
module.exports = {"duration":"style__duration__Ndh-T"};